import { CreateButton, FilterButton, TopToolbar } from 'react-admin'

const InvoiceListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton variant='contained' color='success' />
    </TopToolbar>
  )
}

export default InvoiceListActions